var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOilindustry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7507 10.4166C18.7507 9.37498 17.709 8.33331 15.6257 8.33331H14.584C13.7552 8.33331 12.9603 8.00407 12.3743 7.41802C11.7882 6.83197 11.459 6.03711 11.459 5.20831V2.08331",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.25C9.375 9.40938 6.25 6.25 6.25 6.25C6.25 6.25 3.125 9.40938 3.125 11.25C3.125 13.0906 4.52396 14.5833 6.25 14.5833C7.97604 14.5833 9.375 13.0906 9.375 11.25Z",
    stroke: "#721372",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 21.875H21.875V12.5H18.75V17.1875M18.75 21.875V17.1875M18.75 21.875H10.9375V17.1875L15.1042 14.5833L18.75 17.1875M21.875 10.4166C21.875 4.16665 17.7083 4.16665 17.7083 4.16665C17.7083 4.16665 21.875 4.68748 21.875 2.08331",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilindustry);
export default __webpack_public_path__ + "static/media/oilindustry.678b1fdeb48f94639cc21ab12aab0ae7.svg";
export { ForwardRef as ReactComponent };